module.exports = __webpack_public_path__ + "resources/img/img_akamaiAAP.2a40068777e49c7db7162368438203bf.png";